import Button from 'components/Button';
import styles from './styles/PhotoGalleryAlertModal.module.scss';
import { usePhotoGalleryContainer } from '..';

export default function PhotoGalleryLicenseAgreement() {
  const [{}, { setAlertType }] = usePhotoGalleryContainer();
  return (
    <>
      <div className={styles.ModalHeading}>License Agreement</div>
      <div className={styles.ModalBody}>
        <h2>SBLive Sports Non-Commercial Image License Agreement</h2>
        <p>By clicking Checkout when purchasing a digital image you are agreeing to the following terms.</p>
        <p>
          This Agreement governs personal use of any digital image purchased from SBLive Sports under the terms of the non-commercial,
          royalty-free image license.
        </p>
        <h3>Terms and Conditions Of Use</h3>
        <p>
          This is a legal agreement ("Agreement") between you ("Licensee" or "you") and SBLive Sports (hereinafter referred to as
          "Licensor", "website", "site", “us”, or "we").
        </p>
        <p>
          Each digital image can be downloaded from this website only after a personal license has been purchased. By downloading any
          digital image set to be used on the non-commercial, personal basis from our website, you agree to be bound by the terms of this
          agreement.
        </p>
        <h3>Grant of License</h3>
        <p>
          Licensor grants to you a non-exclusive, worldwide and perpetual, non-commercial, non-sublicensable right to use the licensed
          digital image (the “Digital Image”) for your personal and/or family use.
        </p>
        <p>
          The Digital Image may only be used in materials for personal, non-commercial, non-editorial use. Licensee may create digital
          copies and prints to allow the Digital Image to be viewed by family members of Licensee only. Licensee may not utilize the Digital
          Image in any manner that is not expressly permitted in this license agreement.
        </p>
        <p>
          The Digital Image may not be used in any commercial or editorial materials distributed to the public, including but not limited
          to, newspapers, magazines, school yearbooks, school newspapers, advertising and marketing materials or any commercial online,
          broadcast or other electronic distribution system.
        </p>
        <p>
          The Digital Image may only be used in a personal manner and may not be used for any editorial, commercial, promotional,
          advertising or merchandising use. For clarity: (i) the Digital Image may be posted and shared via social media platforms, but any
          form of commercial, sponsored or monetized use is prohibited; and (ii) the Digital Image may also be used as an integral part of a
          personal or family web site, but if the web site displays advertising the Digital Image may not be used.
        </p>
        <p>Licensee may alter, crop, manipulate and create derivative works of the Digital Image for personal use.</p>
        <p>Licensor and copyright holder(s) reserve all rights not expressly granted to Licensee herein.</p>
        <p>
          The Digital Image may not be used in any defamatory, libelous or otherwise unlawful manner whether directly or in context or
          juxtaposition with specific subject matter.
        </p>
        <p>The Digital Image shall not be incorporated into a logo, trademark or service mark.</p>
        <h3>No Releases</h3>
        <p>
          Licensor gives no rights and makes no warranties with regard to the use of names, trademarks, logos, registered, unregistered or
          copyrighted designs or works of art depicted in the Digital Image. No model, property, team logo, trademark or other rights or
          releases are delivered by Licensor in connection with the delivery of the Digital Image hereunder.
        </p>
        <h3>Warranty</h3>
        <p>
          Licensor(s) or website make no warranty, express or implied, including, without limitation, any implied warranties of
          merchantability or fitness for a particular purpose. Some states do not permit the exclusion of implied warranties, and you may
          have other rights, which may vary from state to state. Neither we nor the copyright holders shall be liable to you or any other
          person or entity for any general, special, direct, indirect, consequential, incidental, or other damages arising out of this
          license or otherwise.
        </p>
        <p>
          Licensee agrees to indemnify and hold Licensor and copyright holders harmless against all claims arising out of any breach of this
          Agreement by Licensee.
        </p>
        <h3>Taxes</h3>
        <p>
          Licensee agrees to pay and be responsible for any and all sales taxes, use taxes, value added taxes and duties imposed by any
          jurisdiction as a result of this license granted to Licensee, or of Licensee’s use of the Digital Image pursuant to this
          Agreement.
        </p>
        <h3>General</h3>
        <p>
          The Digital Image is licensed only to you. Typically, SBLive Sports does not own copyright ownership to the Digital Image and acts
          as an authorized agent and distributor of the Digital Image for the applicable copyright holders. Copyright holders are protected
          by United States copyright laws, international treaty provisions and other applicable laws. Copyright holders and Licensor(s)
          retain all rights not expressly granted by this agreement.
        </p>
        <p>
          The license contained in this Agreement will terminate automatically without notice from Licensor(s) or this website if you fail
          to comply with any provision of this Agreement.
        </p>
        <p>
          Use of the Digital Image must be in compliance with all applicable law, including, but not limited to, laws and regulations
          relating to currency and the law of moral rights.
        </p>
        <p>
          This contract contains all the terms of the license agreement and no terms or conditions may be added or deleted unless made in
          writing and signed by an authorized representative of all parties.
        </p>
        <h3>Governing Law</h3>
        <p>
          This Agreement shall be governed by the internal law of the State of Washington, without regard to conflict of law principles that
          would result in the application of any law other than the law of the State of Washington.
        </p>
        <h3>Severability</h3>
        <p>
          The invalidity or unenforceability of any provision hereof shall in no way affect the validity or enforceability of any other
          provision.
        </p>
        <h3>Entire Agreement</h3>
        <p>
          This Agreement constitutes the full and entire understanding and agreement between the parties with respect to the subject matter
          hereof, and any other written or oral agreements relating to the subject matter hereof existing between the parties are expressly
          canceled.
        </p>
        <h3>Dispute Resolution</h3>
        <p>
          Any unresolved controversy or claim arising out of or relating to this Agreement, except as (i) otherwise provided in this
          Agreement, or (ii) any such controversies or claims arising out of either party’s intellectual property rights for which a
          provisional remedy or equitable relief is sought, shall be submitted to arbitration in accordance with the then-current rules of
          the American Arbitration Association by one (1) arbitrator appointed by the American Arbitration Association. The arbitration
          shall take place in Spokane, Washington, and judgment upon any award rendered in such arbitration will be binding and may be
          entered in any court having jurisdiction thereof.
        </p>
        <p>
          Each of the parties to this Agreement consents to personal jurisdiction for any equitable action sought in the U.S. District Court
          for the Eastern District of Washington or any court of the State of Washington having subject matter jurisdiction.{' '}
        </p>
        <p>
          The parties further agree that the arbitration shall be conducted in their individual capacities only and not as a class action or
          other representative action, and the parties expressly waive their right to file a class action or seek relief on a class basis.
          YOU AND SBLIVE AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN ITS INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS
          MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING.
        </p>
        <p>
          You have the right to opt out and not be bound by the arbitration and class action waiver provisions set forth above by sending
          (from the email address you used to create your account) written notice of your decision to opt out to support@scorebooklive.com
          with the subject line, “ARBITRATION AND CLASS ACTION WAIVER OPT-OUT.” The notice must be sent within thirty (30) days of your
          acceptance of this Agreement; otherwise, you shall be bound to arbitrate disputes in accordance with the terms of those
          paragraphs. If you opt out of these arbitration provisions, SBLive will also not be bound by them.
        </p>
        <p>
          In the event that either party opts-out of arbitration under this Agreement, then the parties (a) hereby irrevocably and
          unconditionally submit to the jurisdiction of the state courts of Washington and to the jurisdiction of the United States District
          Court for the Eastern District of Washington for the purpose of any suit, action or other proceeding arising out of or based upon
          this Agreement, (b) agree not to commence any suit, action or other proceeding arising out of or based upon this Agreement except
          in the state courts of Washington or the United States District Court for the Eastern District of Washington, and (c) hereby
          waive, and agree not to assert, by way of motion, as a defense, or otherwise, in any such suit, action or proceeding, any claim
          that it is not subject personally to the jurisdiction of the above-named courts, that its property is exempt or immune from
          attachment or execution, that the suit, action or proceeding is brought in an inconvenient forum, that the venue of the suit,
          action or proceeding is improper or that this Agreement or the subject matter hereof may not be enforced in or by such court.
        </p>
        <p>-SBLive Sports, Inc. 2024</p>
      </div>
      <Button label="Done" type="v2" className={styles.ModalCloseButton} onClick={() => setAlertType(null)} />
    </>
  );
}
